export let CARS = [
  {
    id: 1,
    name: "Localize Autos",
    slogan: "The Best Cars of Rio de Janeiro",
    address: "Copacabana Avenue, 3250",
    passengers_from: 2,
    passengers_to: 5,
    luggage: 2,
    doors_from: 2,
    doors_to: 4,
    thumb: "assets/img/car/thumb/car_1.jpg",
    price: 100,
    cars: [
      {
        id: 1,
        name: "Ford Focus B2017",
        thumb: "assets/img/car/thumb/car_1.jpg",
        price: 100,
        doors: 2,
        passengers: 4,
        automatic_transmission: 0,
        free_miles: 150,
        address: "Copacabana Avenue, 3250 - Rio de Janeiro",
        location: {
          lat: -22.906847,
          lon: -43.172896
        }
      },
      {
        id: 2,
        name: "Volkswagen Jetta Tbi",
        thumb: "assets/img/car/thumb/car_4.jpg",
        price: 250,
        doors: 4,
        passengers: 5,
        automatic_transmission: 1,
        free_miles: 250,
        address: "Copacabana Avenue, 3250 - Rio de Janeiro",
        location: {
          lat: -22.969778,
          lon: -43.186859
        }
      }
    ]
  },
  {
    id: 2,
    name: "Beach Cars",
    slogan: "The Best Cars of Rio de Janeiro",
    address: "Copacabana Avenue, 3250",
    passengers_from: 2,
    passengers_to: 5,
    luggage: 2,
    doors_from: 2,
    doors_to: 4,
    thumb: "assets/img/car/thumb/car_2.jpg",
    price: 250,
    cars: [
      {
        id: 1,
        name: "Ford Focus B2017",
        thumb: "assets/img/car/thumb/car_2.jpg",
        price: 100,
        doors: 2,
        passengers: 4,
        automatic_transmission: 0,
        free_miles: 150,
        address: "Copacabana Avenue, 3250 - Rio de Janeiro",
        location: {
          lat: -22.906847,
          lon: -43.172896
        }
      },
      {
        id: 2,
        name: "Volkswagen Jetta Tbi",
        thumb: "assets/img/car/thumb/car_3.jpg",
        price: 250,
        doors: 4,
        passengers: 5,
        automatic_transmission: 1,
        free_miles: 250,
        address: "Copacabana Avenue, 3250 - Rio de Janeiro",
        location: {
          lat: -22.969778,
          lon: -43.186859
        }
      }
    ]
  },
  {
    id: 3,
    name: "Speedy Cars",
    slogan: "The Best Cars of Rio de Janeiro",
    address: "Copacabana Avenue, 3250",
    passengers_from: 2,
    passengers_to: 5,
    luggage: 2,
    doors_from: 2,
    doors_to: 4,
    thumb: "assets/img/car/thumb/car_3.jpg",
    price: 200,
    cars: [
      {
        id: 1,
        name: "Ford Focus B2017",
        thumb: "assets/img/car/thumb/car_3.jpg",
        price: 100,
        doors: 2,
        passengers: 4,
        automatic_transmission: 0,
        free_miles: 150,
        address: "Copacabana Avenue, 3250 - Rio de Janeiro",
        location: {
          lat: -22.906847,
          lon: -43.172896
        }
      },
      {
        id: 1,
        name: "Volkswagen Jetta Tbi",
        thumb: "assets/img/car/thumb/car_1.jpg",
        price: 250,
        doors: 4,
        passengers: 5,
        automatic_transmission: 1,
        free_miles: 250,
        address: "Copacabana Avenue, 3250 - Rio de Janeiro",
        location: {
          lat: -22.969778,
          lon: -43.186859
        }
      }
    ]
  },
  {
    id: 4,
    name: "J&F Rent a Car",
    slogan: "The Best Cars of Rio de Janeiro",
    address: "Copacabana Avenue, 3250",
    passengers_from: 2,
    passengers_to: 5,
    luggage: 2,
    doors_from: 2,
    doors_to: 4,
    thumb: "assets/img/car/thumb/car_4.jpg",
    price: 350,
    cars: [
      {
        id: 1,
        name: "Ford Focus B2017",
        thumb: "assets/img/car/thumb/car_4.jpg",
        price: 100,
        doors: 2,
        passengers: 4,
        automatic_transmission: 0,
        free_miles: 150,
        address: "Copacabana Avenue, 3250 - Rio de Janeiro",
        location: {
          lat: -22.906847,
          lon: -43.172896
        }
      },
      {
        id: 2,
        name: "Volkswagen Jetta Tbi",
        thumb: "assets/img/car/thumb/car_2.jpg",
        price: 250,
        doors: 4,
        passengers: 5,
        automatic_transmission: 1,
        free_miles: 250,
        address: "Copacabana Avenue, 3250 - Rio de Janeiro",
        location: {
          lat: -22.969778,
          lon: -43.186859
        }
      }
    ]
  }
]
